import getFullName from '@/utils/getFullName.js'

export default {
  computed: {
    $currentUser() {
      const currentUser = this.$store.state.user.currentUser

      return {
        ...currentUser,
        fullName: getFullName(currentUser),
      }
    },
  },
}
